import { createApi } from "@reduxjs/toolkit/query/react"

import { ApiTypes, UITypes } from "types"

import { baseQueryWithAuth } from "utils/api"
import { prepareQueryParams } from "utils/prepareQueryParams"
import { EditThermostatDeviceData, EditThermostatRequestBody } from "modals/EditThermostatModal/types"

export const devicesApi = createApi({
  reducerPath: "devices",
  tagTypes: ["devices"],
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getDevices: builder.query<ApiTypes.Res.Devices, UITypes.Params>({
      query: arg => ({
        url: `/devices`,
        params: prepareQueryParams(arg),
        headers: { Accept: "application/json" },
      }),
      providesTags: ["devices"],
    }),
    getThermostatBySn: builder.query<EditThermostatDeviceData, string>({
      query: sn => ({
        url: `/devices/device/${sn}`,
        headers: { Accept: "application/json" },
      }),
      providesTags: ["devices"],
    }),
    editThermostat: builder.mutation<void, { sn: string; body: EditThermostatRequestBody }>({
      query: ({ sn, body }) => ({
        url: `/devices/device/${sn}`,
        method: "POST",
        body,
        headers: { Accept: "application/json" },
      }),
      invalidatesTags: ["devices"],
    }),
  }),
})

export const { useLazyGetDevicesQuery, useGetDevicesQuery, useGetThermostatBySnQuery, useEditThermostatMutation } =
  devicesApi

export const getDevices = devicesApi.endpoints.getDevices
